import ApiSponsorships from '@/api/apiSponsorships'
import Sponsorship from '@/models/sponsorship'
import { createActionHelpers } from 'vuex-loading'

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading'
  });
  
  const state = {
    sponsorships: [],
    sponsorship: new Sponsorship()
  }

  const actions = {
    loadSponsorships( context, data ) {

    startLoading( context.dispatch, 'loading sponsorships' );

    ApiSponsorships.all(
        sponsorships => {

          context.commit( 'updateSponsorships' , sponsorships );
          endLoading( context.dispatch, 'updating sponsorships' )
        }, e => {
            
          console.error( 'Error: trying to get sponsorships list...', e );
          endLoading( context.dispatch, 'updating sponsorships' )
        });
    },
    async loadSponsorship( context, { id, callback = () => {}, errorCallback = () => {} } ) {

      startLoading( context.dispatch, 'loading a sponsorship' );
      
      ApiSponsorships.get(
        id,
        sponsorship => {
          
          context.commit( 'updateSponsorship', sponsorship );
          endLoading( context.dispatch, 'loading a sponsorship' );
          callback();
        }, e => {
          
          console.error( 'Error: trying to load sponsorship...', e );
          endLoading( context.dispatch, 'loading a sponsorship' );
          errorCallback( e );
        }
      );
    },
    createSponsorship( context, sponsorship ) {

      startLoading( context.dispatch, 'creating sponsorship' );

      ApiSponsorships.create(
        sponsorship,
        response => {

          endLoading( context.dispatch, 'creating sponsorship' );
          context.dispatch( 'goSponsorships' );
        }, e => {
          
          console.error( 'Error: trying to create a sponsorship...', e );
          endLoading( context.dispatch, 'creating sponsorship' );
        }
      );
    },
    editSponsorship( context, { id, data, callback, errorCallback = () => {} } ) {
      
      startLoading( context.dispatch, 'updating sponsorship' );

      ApiSponsorships.updateSponsorship(
        { id, data },
        response => {
          
          context.dispatch( 'updateSponsorship', response.data );
          endLoading( context.dispatch, 'updating sponsorship' );
          callback();
        }, e => {

          errorCallback();
          endLoading( context.dispatch, 'updating sponsorship' );
        }
      )
    },
    createSection( context, { data, callback = () => {}, errorCallback = () => {} } ) {
      
      startLoading( context.dispatch, 'creating section' );

      ApiSponsorships.createSection(
        data,
        response => {
          
          // context.dispatch( 'updateSponsorship', response.data );
          endLoading( context.dispatch, 'creating content' );
          callback( response.data.data );
        }, e => {

          errorCallback();
          endLoading( context.dispatch, 'creating section' );
        }
      )
    },
    editSection( context, { data, callback = () => {}, errorCallback = () => {} } ) {
      
      startLoading( context.dispatch, 'updating section' );

      ApiSponsorships.updateSection(
        data,
        response => {
          
          // context.dispatch( 'updateSponsorship', response.data );
          endLoading( context.dispatch, 'updating section' );
          callback( response.data.data );
        }, e => {

          errorCallback();
          endLoading( context.dispatch, 'updating section' );
        }
      )
    },
    addSectionContent( context, { data, callback = () => {}, errorCallback = () => {} } ) {
      
      startLoading( context.dispatch, 'adding section content' );

      ApiSponsorships.addSectionContent(
        data,
        response => {
          
          endLoading( context.dispatch, 'adding section content' );
          callback( response.data.data );
        }, e => {

          errorCallback();
          endLoading( context.dispatch, 'adding section content' );
        }
      )
    },
    editSectionContent( context, { data, callback = () => {}, errorCallback = () => {} } ) {
      
      startLoading( context.dispatch, 'updating section content' );

      ApiSponsorships.updateSectionContent(
        data,
        response => {
          
          // context.dispatch( 'updateSponsorship', response.data );
          endLoading( context.dispatch, 'updating section content' );
          callback( response.data.data );
        }, e => {

          errorCallback();
          endLoading( context.dispatch, 'updating section content' );
        }
      )
    },
    deleteSectionContent( context, { id, callback = () => {}, errorCallback = () => {} } ) {
      
      startLoading( context.dispatch, 'deleting section content' );
      ApiSponsorships.deleteSectionContent(
        id,
        response => {
          
          // context.dispatch( 'updateSponsorship', response.data );
          endLoading( context.dispatch, 'deleting section content' );
          callback( response.data.data );
        }, e => {

          errorCallback();
          endLoading( context.dispatch, 'deleting section content' );
        }
      )
    },
    addEvidence( context, { data, callback = () => {}, errorCallback = () => {} } ) {
      
      startLoading( context.dispatch, 'updating section content' );

      ApiSponsorships.addEvidence(
        data,
        response => {
          
          // context.dispatch( 'updateSponsorship', response.data );
          endLoading( context.dispatch, 'creating evidence' );
          callback( response.data.data );
        }, e => {

          errorCallback();
          endLoading( context.dispatch, 'creating evidence' );
        }
      )
    },
    deleteEvidence( context, { id, callback = () => {}, errorCallback = () => {} } ) {

      startLoading( context.dispatch, 'deleting evidence' );
      
      ApiSponsorships.deleteEvidence(
        id,
        response => {
          
          endLoading( context.dispatch, 'deleting evidence' );
          callback( response.data.data );
        }, e => {

          errorCallback();
          endLoading( context.dispatch, 'deleting sponsorship' );
        }
      );
    },
    editEvidence( context, { data, callback = () => {}, errorCallback = () => {} } ) {
      
      startLoading( context.dispatch, 'updating section content' );

      ApiSponsorships.updateEvidence(
        data,
        response => {
          
          // context.dispatch( 'updateSponsorship', response.data );
          endLoading( context.dispatch, 'updating evidence' );
          callback( response.data.data );
        }, e => {

          errorCallback();
          endLoading( context.dispatch, 'updating evidence' );
        }
      )
    },
    addOptionEvidence( context, { data, callback = () => {}, errorCallback = () => {} } ) {
      
      startLoading( context.dispatch, 'updating section content' );

      ApiSponsorships.addOptionEvidence(
        data,
        response => {
          
          // context.dispatch( 'updateSponsorship', response.data );
          endLoading( context.dispatch, 'adding option evidence' );
          callback( response.data.data );
        }, e => {

          errorCallback();
          endLoading( context.dispatch, 'adding option evidence' );
        }
      )
    },
    editOptionEvidence( context, { data, callback = () => {}, errorCallback = () => {} } ) {
      
      startLoading( context.dispatch, 'updating section content' );

      ApiSponsorships.updateOptionEvidence(
        data,
        response => {
          
          // context.dispatch( 'updateSponsorship', response.data );
          endLoading( context.dispatch, 'updating option evidence' );
          callback( response.data.data );
        }, e => {

          errorCallback();
          endLoading( context.dispatch, 'updating option evidence' );
        }
      )
    },
    deleteOptionEvidence( context, { id, callback = () => {}, errorCallback = () => {} } ) {
      
      startLoading( context.dispatch, 'updating section content' );

      ApiSponsorships.deleteOptionEvidence(
        id,
        response => {
          
          // context.dispatch( 'updateSponsorship', response.data );
          endLoading( context.dispatch, 'deleting option evidence' );
          callback( response.data.data );
        }, e => {

          errorCallback();
          endLoading( context.dispatch, 'deleting option evidence' );
        }
      )
    }
  };

  const mutations = {
    updateSponsorships( state, sponsorships ) {

        state.sponsorship = new Sponsorship();
        state.sponsorships = sponsorships;
    },
    updateSponsorship( state, sponsorship ) {

      state.sponsorship = sponsorship;
      state.sponsorships = [];
    }
  };

  const getters = {
    currentSponsorships( state ) {
          
        return state.sponsorships;
    },
    currentSponsorship( state ) {

      return state.sponsorship;
    }
  };

  export default {
      state,
      actions,
      mutations,
      getters
  }


// WEBPACK FOOTER //
// ./src/store/sponsorships.js